<nav *transloco="let t" [attr.aria-label]="t('pagination.ariaLabel')" class="w-full flex items-center gap-3">
  <!-- Page Size Selector (left aligned) -->
  <div class="flex-1 flex justify-start min-w-0">
    <app-input-select-uif
      (valueChange)="onPageSizeChange($event)"
      [ariaLabel]="t('pagination.rowsPerPage')"
      [dropdownDirection]="'up'"
      [labelPosition]="'left'"
      [label]="t('pagination.rowsPerPage')"
      [options]="pageSizeColumnOptions"
      [tabIndex]="1"
      [value]="pageSize()?.toString()"
      inputSize="w-20"
    ></app-input-select-uif>
  </div>

  <!-- Pagination Buttons (centered) -->
  <div class="flex-none mx-auto">
    <div class="join" role="group">
      <button
        (click)="emitPaginationChange((page() ?? 0) - 1, pageSize() ?? defaultPageSize)"
        [attr.aria-label]="t('pagination.previous')"
        [disabled]="(page() ?? 0) <= 1"
        class="join-item btn"
      >
        <span aria-hidden="true">«</span>
      </button>

      @for (p of pageNumbers(); track p) {
        @if (p === "...") {
          <span class="join-item btn btn-disabled" aria-hidden="true">...</span>
        } @else {
          <button
            class="join-item btn"
            [class.btn-active]="p === page()"
            [attr.aria-current]="p === page() ? 'page' : null"
            (click)="emitPaginationChange(+p, pageSize() ?? defaultPageSize)"
            [attr.aria-label]="t('pagination.goToPage', { page: p })"
          >
            {{ p }}
          </button>
        }
      }
      <button
        (click)="emitPaginationChange((page() ?? 0) + 1, pageSize() ?? defaultPageSize)"
        [attr.aria-label]="t('pagination.next')"
        [disabled]="(page() ?? 0) >= totalPages()"
        class="join-item btn"
      >
        <span aria-hidden="true">»</span>
      </button>
    </div>
  </div>

  <!-- Empty div for spacing on the right -->
  <div class="flex-1 flex justify-end min-w-0">
    <ng-content></ng-content>
  </div>
</nav>
